import { observable, computed, action } from 'mobx'
import { task } from 'mobx-task'
import memoize from 'memoizee'

// No pun intended
export default class TaxStatesState {
  stepId = 'TaxStates'
  title = 'Select the states where you earn income'
  trackingId = 'Onboarding - State Selection'

  @observable states = []

  constructor ({ wizard }) {
    this.wizard = wizard
    this.wizard.rootStore.authStore.onLogin(() => this.fetchStates())
    this.fetchStates = this.fetchStates.wrap(fn => memoize(fn, { promise: true, length: 0 }))
  }

  @computed get relevantStates () {
    const projectType = this.wizard.getStep('ProjectType').legend
    if (!projectType) {
      return []
    }

    // Each state has either personal or business price, or both.
    // Filter out the ones not relevant for the current project type.
    return this.states.filter(x => x.properties.some(x => x.id === projectType.id))
  }

  @computed get nextEnabled () {
    return this.selectedStates.length > 0
  }

  @computed get selectedStates () {
    return this.relevantStates.filter(x => x.selected)
  }

  @computed get continueButtonText () {
    return this.selectedStates.length > 0 ? `${this.selectedStates.length} selected` : 'Please select'
  }

  @task async fetchStates () {
    const data = await this.wizard.rootStore.api.states.find()
    this.setStates(data)
  }

  @action setStates (data) {
    this.states.replace(data.map(d => new State(d)))
  }

  async activate () {
    await this.fetchStates()
  }

  serializeToJob () {
    return {
      coverage_states: this.selectedStates.map(x => x.name)
    }
  }

  async hydrate (job) {
    if (job.states) {
      await this.fetchStates()
      this.states.forEach(y => job.states.indexOf(y.name) > -1 && y.setSelected(true))
    }
  }
}

/**
 * Used in a checklist.
 */
class State {
  @observable name = ''
  @observable properties = []
  @observable selected = false

  constructor (state) {
    Object.assign(this, state)
  }

  @action setSelected (selected) {
    this.selected = selected
  }

  propertiesFor (legendId) {
    return this.properties.find(x => x.id === legendId)
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/ProjectWizard/Steps/TaxStates/TaxStatesState.js